
import moment from 'moment/moment';
import React, { createContext, useContext, useState } from 'react';
import { useSelector } from 'react-redux';
import { useListCompanyPreferenceQuery } from '../../../redux/apis/companyPreference.api';

const InvoiceStateListContext = createContext();

export const HandleInvoiceStateProvider = ({ children }) => {
  const userPreferenceAndFY = useSelector((state) => state?.userPrefrenceandReducer);
    const { data: companyPreference } = useListCompanyPreferenceQuery();
      const postingDatePref = companyPreference?.find(
        (p) => p.attributetypecd === 'MyPostingDate' && String(p?.additionalvalue ?? '') === String(userPreferenceAndFY?.financialYear?.financialyearid ?? '')
      );
      const currentPostedDate = postingDatePref?.attributevalue;
      // const fyStartDate =currentPostedDate? moment(currentPostedDate * 1000).format('YYYY-MM-DD'): moment(userPreferenceAndFY?.financialYear?.startdate * 1000).format('YYYY-MM-DD');
      const fyStartDate="";

  const fyEndDate =  moment(userPreferenceAndFY?.financialYear?.enddate * 1000).format('YYYY-MM-DD');
  let today = new Date();
  let yy = today.getFullYear();
  let mm = today.getMonth() + 1;
  let dd = today.getDate();

  if (dd < 10) dd = '0' + dd;
  if (mm < 10) mm = '0' + mm;
  let urlContains =
    window.location.href.includes('addnewinvoicetax') ||
    window.location.href.includes('newpos') ||
    window.location.href.includes('addcreditnote');
  const todayDate = yy + '-' + mm + '-' + dd;

  const resetData = {
    orderNumber: '',
    entryDate:
      //  moment(todayDate).isBetween(
      //   fyStartDate,
      //   fyEndDate,
      //   undefined,
      //   "[]"
      // )
      //   ? todayDate
      //   : fyStartDate,
      // invoiceDate: moment(todayDate).isBetween(
      //   fyStartDate,
      //   fyEndDate,
      //   undefined,
      //   "[]"
      // )
      //   ? todayDate
      //   :
      fyStartDate,
    customerOrderDate: '',
    //  moment(todayDate).isBetween(
    //   fyStartDate,
    //   fyEndDate,
    //   undefined,
    //   "[]"
    // )
    //   ? todayDate
    //   : fyStartDate,
    voucherNumber: '',
    partyInvNo:'',
    partyName:
      window.location.href.indexOf('newpos') > 0 ||
      window.location.href.indexOf('viewpos') > 0 ||
      window.location.href.indexOf('editpos') > 0
        ? ''
        : { label: '', value: '', gstCategorey: '' },
    supplier: '',
    paymentType:
      window.location.href.indexOf('newpos') > 0 ||
      window.location.href.indexOf('viewpos') > 0 ||
      window.location.href.indexOf('editpos') > 0
        ? 'Cash'
        : 'Credit',
    receivedAmount: 0,
    receivedAccount:
      window.location.href.indexOf('newpos') > 0 ||
      window.location.href.indexOf('viewpos') > 0 ||
      window.location.href.indexOf('editpos') > 0
        ? { label: 'Cash A/c', value: 3 }
        : { label: '', value: '' },
    creditPeriod: '',
    bankReferenceNo: '',
    dueDate:
      //  moment(todayDate).isBetween(
      //   fyStartDate,
      //   fyEndDate,
      //   undefined,
      //   "[]"
      // )
      //   ? todayDate
      //   :
      fyStartDate,
    tdsFlag: '',
    tdsOptions: '',
    tdsAmount: 0, //""
    adjustments: 0, //""
    currency: { label: 'Rupee (₹)', value: '1', sign: '₹', code: 'INR' },
    currencyRate: 1,
    ineligibleITCFlag: '',
    reverseChargeFlag: 0,
    remarks: '',
    placeOfSupply: { label: '', value: '' },
    address: '',
    billingAddress: '',
    deliveryAddress: '',
    gstin: '',
    transportMode: '',
    vehicleNumber: '',
    dateOfDispatch:
      // moment(todayDate).isBetween(
      //   fyStartDate,
      //   fyEndDate,
      //   undefined,
      //   "[]"
      // )
      //   ? todayDate
      //   :
      '',
      // fyStartDate,
    gstCategory: '',
    ewayBillNo: '',
    transactionVoucher: '',
    CancelFlag: 0,
    tcsFlag: 0,
    tcsOptions: '',
    tdsPercent: 0,
    tcsPercent: 0,
    tcsAmount: 0,
    manualTCSAmt: 0,
    manualTDSAmt: 0,
    seriesVouchers: { label: '', value: '' ,serialflag:0},
    transactionSeries: { label: '', value: '' },
    consigneeName: '',
    consigneeGST: '',
    roundOff: '',
    adjustmentsType: '1',
    adjustmentsValue: 0,
    balanceDueAmt: 0,
    partyCategory: '',
    manualTcsFlag: 0,
    manualTdsFlag: 0,
    partyCreditLimit: 0,
    paymentDeletionFlag: false,
    taxability: { label: '', value: '' },taxType:0,ITCFlag:0,
    originalInvoiceNumber: {
      label: '',
      value: '',
      regType: '',
      taxability: '',
      invDate: '',
      currencycode: '',
      stateName:'',
      stateCode:''
    },
    partyContactNumber: '',
    cashPayment: true,
    bankPayment: false,
    bankReceivedAmount: 0,
    bankReceivedAccount: { label: '', value: '' },
    sameAsBilling: false,
    errorStatus: {
      partyInvNo:false,
      orderNumber: false,
      entryDate: false,
      invoiceDate: false,
      customerOrderDate: false,
      voucherNumber: false,
      partyName: false,
      paymentType: false,
      receivedAmount: false,
      receivedAccount: false,
      creditPeriod: false,
      bankReferenceNo: false,
      dueDate: false,
      tdsFlag: false,
      tdsOptions: false,
      tdsAmount: false,
      tcsFlag: false,
      tcsOptions: false,
      tcsAmount: false,
      adjustments: false,
      ineligibleITCFlag: false,
      reverseChargeFlag: false,
      remarks: false,
      placeOfSupply: false,
      address: false,
      currency: false,
      gstin: false,
      currencyRate: false,
      transportMode: false,
      vehicleNumber: false,
      dateOfDispatch: false,
      ewayBillNo: false,
      transactionVoucher: false,
      seriesVouchers: false,
      transactionSeries: false,
      consigneeName: false,
      consigneeGST: false,
      roundOff: false,
      tdsPercent: false,
      tcsPercent: false,
      adjustmentsType: false,
      adjustmentsValue: false,
      balanceDueAmt: false,
      taxability: false,
      originalInvoiceNumber: false,
      partyContactNumber: false,
    },
    errorFields: {
         partyInvNo:'',
      orderNumber: '',
      entryDate: '',
      invoiceDate: '',
      customerOrderDate: '',
      voucherNumber: '',
      partyName: '',
      paymentType: '',
      receivedAmount: '',
      receivedAccount: '',
      creditPeriod: '',
      bankReferenceNo: '',
      dueDate: '',
      tcsFlag: '',
      tcsOptions: '',
      tcsAmount: '',
      tdsFlag: '',
      tdsOptions: '',
      currency: '',
      tdsAmount: '',
      adjustments: '',
      ineligibleITCFlag: '',
      currencyRate: '',
      reverseChargeFlag: '',
      remarks: '',
      placeOfSupply: '',
      address: '',
      gstin: '',
      transportMode: '',
      vehicleNumber: '',
      dateOfDispatch: '',
      ewayBillNo: '',
      transactionVoucher: '',
      seriesVouchers: '',
      transactionSeries: '',
      consigneeName: '',
      consigneeGST: '',
      tdsPercent: '',
      tcsPercent: '',
      roundOff: '',
      adjustmentsType: '',
      adjustmentsValue: '',
      balanceDueAmt: '',
      taxability: '',
      originalInvoiceNumber: '',
      partyContactNumber: '',
    },
  };
  const resetItems = {
    itemCode: { label: '', value: '' },
    name: { label: '', value: '' },
    priceType: { label: '', value: 0 },
    priceTypeArr: [],
    ledgerAccount: { label: '', value: '' },
    HSN: {
      label: '',
      value: '',
      companyID: '',
      hsnID: '',
      codeType: '',
      description: '',
    },
    qty: 0,
    units: { label: '', value: '' },
    rate: 0,
    amount: 0,
    dicount: 0,discountType:'Amount',discountRate:'',
    effectiveFrom: 0,
    effectiveTo: 0,
    taxableAMount: 0,
    GSTRate: '',manualGSTFlag:0,
    taxability: { label: '', value: '' },taxType:0,ITCFlag:0,
    manualDiscount: false,
     manualCess: 0,cessType:'Amount',cessRate:'',
    autoCess: 0,
    autoDiscount: 0,
    IGST: 0,
    CGST: '0.00',
    SGST: '0.00',
    GSTCess: 0,
    netAmount: '0000',
    editable: true,
    new: true,
    reason: '',
  };
  const resetNonItems = {
    ledgerAccount: { label: '', value: '' },
    HSN: {
      label: '',
      value: '',
      companyID: '',
      hsnID: '',
      codeType: '',
      description: '',
    },
    description: '',
    taxableAMount: 0,
    GSTRate: '',manualGSTFlag:0,
    taxability: { label: '', value: '' },taxType:0,ITCFlag:0,
    manualDiscount: false,
     manualCess: 0,cessType:'Amount',cessRate:'',
    autoCess: 0,
    autoDiscount: 0,
    IGST: 0,
    CGST: '0.00',
    SGST: '0.00',
    GSTCess: 0,
    netAmount: 0,
    editable: true,
    new: true,
    reason: '',
  };

  const [initialState, setInitialState] = useState({
    orderNumber: '',
    partyInvNo:'',
    entryDate:
      // moment(todayDate).isBetween(
      //   fyStartDate,
      //   fyEndDate,
      //   undefined,
      //   "[]"
      // )
      //   ? todayDate
      //   :
      fyStartDate,
    invoiceDate:
      //  moment(todayDate).isBetween(
      //   fyStartDate,
      //   fyEndDate,
      //   undefined,
      //   "[]"
      // )
      //   ? todayDate
      //   :
      fyStartDate,
    customerOrderDate: '',
    //  moment(todayDate).isBetween(
    //   fyStartDate,
    //   fyEndDate,
    //   undefined,
    //   "[]"
    // )
    //   ? todayDate
    //   : fyStartDate,
    voucherNumber: '',
    partyName:
      window.location.href.indexOf('newpos') > 0 ||
      window.location.href.indexOf('viewpos') > 0 ||
      window.location.href.indexOf('editpos') > 0
        ? ''
        : { label: '', value: '', gstCategorey: '' },
    supplier: '',
    paymentType:
      window.location.href.indexOf('newpos') > 0 ||
      window.location.href.indexOf('viewpos') > 0 ||
      window.location.href.indexOf('editpos') > 0
        ? 'Cash'
        : 'Credit',
    receivedAmount: 0,
    receivedAccount:
      window.location.href.indexOf('newpos') > 0 ||
      window.location.href.indexOf('viewpos') > 0 ||
      window.location.href.indexOf('editpos') > 0
        ? { label: 'Cash A/c', value: 3 }
        : { label: '', value: '' },
    creditPeriod: '',
    bankReferenceNo: '',
    dueDate:
      //  moment(todayDate).isBetween(
      //   fyStartDate,
      //   fyEndDate,
      //   undefined,
      //   "[]"
      // )
      //   ? todayDate
      //   :
      fyStartDate,
    tdsFlag: '',
    tdsOptions: '',
    tdsAmount: 0, //""
    adjustments: 0, //""
    currency: { label: 'Rupee (₹)', value: '1', sign: '₹', code: 'INR' },
    currencyRate: 1,
    ineligibleITCFlag: '',
    reverseChargeFlag: 0,
    remarks: '',
    placeOfSupply: { label: '', value: '' },
    address: '',
    billingAddress: '',
    deliveryAddress: '',
    gstin: '',
    transportMode: '',
    vehicleNumber: '',
    dateOfDispatch:
      //  moment(todayDate).isBetween(
      //   fyStartDate,
      //   fyEndDate,
      //   undefined,
      //   "[]"
      // )
      //   ? todayDate
      //   :
      '',
      // fyStartDate,
    gstCategory: '',
    ewayBillNo: '',
    transactionVoucher: '',
    CancelFlag: 0,
    tcsFlag: 0,
    tcsOptions: '',
    tdsPercent: 0,
    tcsPercent: 0,
    tcsAmount: 0,
    manualTCSAmt: 0,
    manualTDSAmt: 0,
    seriesVouchers: { label: '', value: '' ,serialflag:0},
    transactionSeries: { label: '', value: '' },
    consigneeName: '',
    consigneeGST: '',
    roundOff: '',
    adjustmentsType: '1',
    adjustmentsValue: 0,
    balanceDueAmt: 0,
    partyCategory: '',
    manualTcsFlag: 0,
    manualTdsFlag: 0,
    partyCreditLimit: 0,
    paymentDeletionFlag: false,
    taxability: { label: '', value: '' },taxType:0,ITCFlag:0,

    originalInvoiceNumber: {
      label: '',
      value: '',
      regType: '',
      taxability: '',
      invDate: '',
       stateName:'',
      stateCode:''
    },
    partyContactNumber: '',
    cashPayment: true,
    bankPayment: false,
    bankReceivedAmount: 0,
    bankReceivedAccount: { label: '', value: '' },
    sameAsBilling: false,
    errorStatus: {
      partyInvNo:false,
      orderNumber: false,
      entryDate: false,
      invoiceDate: false,
      customerOrderDate: false,
      voucherNumber: false,
      partyName: false,
      paymentType: false,
      receivedAmount: false,
      receivedAccount: false,
      creditPeriod: false,
      bankReferenceNo: false,
      dueDate: false,
      tdsFlag: false,
      tdsOptions: false,
      tdsAmount: false,
      tcsFlag: false,
      tcsOptions: false,
      tcsAmount: false,
      adjustments: false,
      ineligibleITCFlag: false,
      reverseChargeFlag: false,
      remarks: false,
      placeOfSupply: false,
      address: false,
      currency: false,
      gstin: false,
      currencyRate: false,
      transportMode: false,
      vehicleNumber: false,
      dateOfDispatch: false,
      ewayBillNo: false,
      transactionVoucher: false,
      seriesVouchers: false,
      transactionSeries: false,
      consigneeName: false,
      consigneeGST: false,
      roundOff: false,
      tdsPercent: false,
      tcsPercent: false,
      adjustmentsType: false,
      adjustmentsValue: false,
      balanceDueAmt: false,
      taxability: false,
      originalInvoiceNumber: false,
      partyContactNumber: false,
      cashPayment: false,
      bankPayment: false,
      bankReceivedAmount: false,
      bankReceivedAccount: false,
    },
    errorFields: {
      partyInvNo:'',
      orderNumber: '',
      entryDate: '',
      invoiceDate: '',
      customerOrderDate: '',
      voucherNumber: '',
      partyName: '',
      paymentType: '',
      receivedAmount: '',
      receivedAccount: '',
      creditPeriod: '',
      bankReferenceNo: '',
      dueDate: '',
      tcsFlag: '',
      tcsOptions: '',
      tcsAmount: '',
      tdsFlag: '',
      tdsOptions: '',
      currency: '',
      tdsAmount: '',
      adjustments: '',
      ineligibleITCFlag: '',
      currencyRate: '',
      reverseChargeFlag: '',
      remarks: '',
      placeOfSupply: '',
      address: '',
      gstin: '',
      transportMode: '',
      vehicleNumber: '',
      dateOfDispatch: '',
      ewayBillNo: '',
      transactionVoucher: '',
      seriesVouchers: '',
      transactionSeries: '',
      consigneeName: '',
      consigneeGST: '',
      tdsPercent: '',
      tcsPercent: '',
      roundOff: '',
      adjustmentsType: '',
      adjustmentsValue: '',
      balanceDueAmt: '',
      taxability: '',
      originalInvoiceNumber: '',
      partyContactNumber: '',
      cashPayment: '',
      bankPayment: '',
      bankReceivedAmount: '',
      bankReceivedAccount: '',
    },
  });
  const [data, setData] = useState({ ...initialState });
  const [invID, setInvID] = useState('');
  const [cancelModal, setCancelModal] = useState(false);
  const [state, setState] = useState({
    reason: '',
    errorFields: {
      reason: '',
    },
    errorStatus: {
      reason: false,
    },
  });

  const [cancelModalStatus, setCancelModalStatus] = useState(false);
  const [itemData, setItemData] = useState({});
  const [deleteModalStatus, setDeleteModalStatus] = useState(false);
  const [eImp, setEImp] = useState(false);
  const [eWayImp, setEwayImp] = useState(false);
  const [eObj, setEObj] = useState(false);
  const [accNames, setAccNames] = useState([]);
  const [viewMode, setViewMode] = useState(false);
  const [fromDayDate, setFromDayDate] = useState('');
  const [endDayDate, setEndDayDate] = useState('');
  const [paymentAccordion, setPaymentAccordion] = useState(true);
  const [deispatchAccordion, setDispatchAccordion] = useState(true);
  const [invoiceEntry, setInvoiceEntry] = useState([]);
  const [tcsOptionValue, setTcsoptionValue] = useState('');
  const [tdsOptionValue, setTdsoptionValue] = useState('');
  const [totTaxAmt, setTotTaxAmt] = useState(0);
  const [totDiscount, setTotDicount] = useState(0);
  const [totGSTCess, setTotGSTCess] = useState(0);
  const [totNetAmt, setTotNetAmt] = useState(0);
  const [totGST, setTotGST] = useState(0);
  const [totAmt, setTotAmt] = useState(0);
  const [companyState, setCompanyState] = useState('');
  const [itemID, setItemID] = useState('');
  const [itemType, setItemType] = useState('');
  const [openAddItemModal, setOpenAddItemModal] = useState(false);
  const [netAmountToPay, setNetAmountToPay] = useState(0);
  const [amountAfterDiscount, setAmountAfterDiscount] = useState(0);
  const [amountAfterTCS, setAmountAfterTCS] = useState(0);
  const [amountAfterTDS, setAmountAfterTDS] = useState(0);
  const [companyData, setCompanyData] = useState([]);
  const [partyDeliveryAddressEntity, setPartyDeliveryAddressEntity] = useState({});
  const [partyBillAddressEntity, setPartyBillAddressEntity] = useState({});
  const [invTransArr, setInvTransArr] = useState([]);
  const [paymentTransArr, setPaymentTransArr] = useState([]);
  const [itemsRows, setItemsRows] = useState([]);
  const [initialAttachments, setInitialAttachments] = useState([]);
  const [tcsSections, setTcsSections] = useState([]);
  const [tdsSections, setTdsSections] = useState([]);
  const [transGeneralSettingsFlag, setTransGeneralSettingsFlag] = useState(-1);
  const [partyNameOptions, setPartyNameOptions] = useState([]);
  const [partyAccountID, setPartyAccountID] = useState('');
  const [linkedTransArr, setLinkedTransArr] = useState([]);
  const [voucherArr, setVoucherArr] = useState([]);
  const [transVoucherArr, setTransVoucherArr] = useState([]);
  const [paymentTransID, setPaymentTransID] = useState('');
  const [displayAllAccounts, setDisplayAllAccounts] = useState(false);
  const [currentVoucherNo, setCurrentVoucherNo] = useState('');
  const [backdropOpen, setBackdropOpen] = useState(true);
  const [units, setunits] = useState([]);
  const [unitsObj, setUnitsObj] = useState({});
  const [lastInvoiceDate, setLastInvoiceDate] = useState('');
  const [firstInvoiceDate, setFirstInvoiceDate] = useState('');
  const [nextInvoiceDate, setNextInvoiceDate] = useState('');
  const [position, setPosition] = useState({ x: 1400, y: 600 });
  const [isDragging, setIsDragging] = useState(false);
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const [registrationType, setRegistrationType] = useState('');
  const [tabvalue, setTabValue] = useState('1');
  const [itemValid, setItemValid] = useState(true);
  const [nonItemValid, setNonItemValid] = useState(true);
  const [isFocusItemRow, setIsFocusItemRow] = useState(false);
  const [isFocusNonItemRow, setIsNonItemFocusRow] = useState(false);
  const [partyType, setPartyType] = useState((urlContains ? 'CUSTOMER' : 'SUPPLIER'));
  // (urlContains ? 'CUSTOMER' : 'SUPPLIER');
  const [tableErrArr, setTableErrArr] = useState([]);
  const [itemCodes, setItemCodes] = useState([]);
  const [itemNames, setItemNames] = useState([]);
  const [selected, setSelected] = useState({});
  const [listOfStates, setListOfStates] = useState([]);
  const [stateArr, setStateArr] = useState([]);
  const [countryArr, setCountryArr] = useState([]);
  const [districtArr, setDistrictArr] = useState([]);
  const [stateName, setStateName] = useState('');
  const [districtName, setDistrictName] = useState('');
  const [countryName, setCountryName] = useState('');
  const [stateDelName, setStateDelName] = useState('');
  const [districtDelName, setDistrictDelName] = useState('');
  const [countryDelName, setCountryDelName] = useState('');
  const [accountBalance, setAccountBalance] = useState(0);
  const [showTransactionModal, setShowTransactionModal] = useState(false);
  const [startDate, setStartDate] = useState(0);
  const [endDate, setEndDate] = useState(0);
  const [partyAccName, setPartyAccName] = useState('');
  const [itemListModalOpen, setItemListModalOpen] = useState(false);
  const [openPartyModal, setOpenPartyModal] = useState(false);
  const [partyCategery, setPartyCategery] = useState(false);
  const [newPartyID, setNewPartyID] = useState('');
  const [partyParamsID, setPartyParamsID] = useState('');
  const [partyID, setPartyID] = useState('');
  const [purchaseArr, setPurchaseArr] = useState([]);
  const [companyGstType, setCompanyGstType] = useState('');
  const [ledgerModal, setLedgerModal] = useState(false);
  const [companyPlaceofState, setCompanyPlaceOfState] = useState('');
  const [openResetModal, setOpenResetModal] = useState(false);
  const [showAllCurrencies, setShowAllCurrencies] = useState(false);
  const [newChangeValue, setNewChangeValue] = useState({
    label: '',
    value: '',
    type: '',
  });
  const [openAccountModal, setAddAccountModal] = useState(false);
  const [openBankAccountModal, setOpenBankAccountModal] = useState(false);
  const [cashAccount, setCashAccount] = useState([]);
  const [bankAccount, setBankAccount] = useState([]);
  const [openSettingsModal, setOpenSettingsModal] = useState(false);
  const [activeTransVouchers, setActiveTransVouchers] = useState([]);
  const [transSerielNos, setTransSerielNo] = useState([]);
  const [newTransVouch, setNewTransVouch] = useState('');
  const [focus, setFocus] = useState('');
  const [newSerilNo, setNewSerialNo] = useState({ lable: '', value: '' });
  const [LastBankAccount, setLastBankAccount] = useState();
  const [openPaymentWarningModal, setOpenPaymentWarningModal] = useState(false);
  const [currentPaymentAccObj, setCurrentPaymentAccObj] = useState({
    label: '',
    value: '',
  });
  const [cashPaymentObj, setCashPaymentObj] = useState({
    label: '',
    value: '',
  });
  const [bankPaymentObj, setBankPaymentObj] = useState({
    label: '',
    value: '',
  });
  const [generalSettingsFlag, setGeneralSettingsFlag] = useState(-1);
  const [activeVouchers, setActiveVouchers] = useState([]);
  const [serialNos, setSerialNos] = useState([]);
  const [originalInvoiceNos, setOriginalInvoiceNos] = useState([]);
  const [lastUsedCashAcc, setLastUsedCashAcc] = useState({
    label: 'Cash A/c',
    value: 3,
  });
  const [lastUsedBankAcc, setLastUsedBankAcc] = useState({
    label: 'Bank A/c',
    value: 39,
  });

  const [items, setItems] = useState([
    {
      itemCode: { label: '', value: '' },
      name: { label: '', value: '' },
      reason: '',
      priceType: { label: '', value: 0 },
      priceTypeArr: [],
      ledgerAccount: { label: '', value: '' },
      HSN: {
        label: '',
        value: '',
        companyID: '',
        hsnID: '',
        codeType: '',
        description: '',
      },
      qty: 0,
      units: { label: '', value: '' },
      rate: 0,
      amount: 0,
      dicount: 0,discountType:'Amount',discountRate:'',
      effectiveFrom: 0,
      effectiveTo: 0,
      taxableAMount: 0,
      GSTRate: '',manualGSTFlag:0,
      taxability: { label: '', value: '' },taxType:0,ITCFlag:0,
      manualDiscount: false,
       manualCess: 0,cessType:'Amount',cessRate:'',
      autoCess: 0,
      autoDiscount: 0,
      IGST: 0,
      CGST: '0.00',
      SGST: '0.00',
      GSTCess: 0,
      netAmount: '0000',
      editable: true,
      new: true,
      description: '',
      
    },
  ]);
  const [nonItems, setNonItems] = useState([
    {
      ledgerAccount: { label: '', value: '' },
      HSN: {
        label: '',
        value: '',
        companyID: '',
        hsnID: '',
        codeType: '',
        description: '',
      },
      reason: '',
      description: '',
      taxableAMount: 0,
      GSTRate: '',manualGSTFlag:0,
      taxability: { label: '', value: '' },taxType:0,ITCFlag:0,
      manualDiscount: false,
       manualCess: 0,cessType:'Amount',cessRate:'',
      autoCess: 0,
      autoDiscount: 0,
      IGST: 0,
      CGST: '0.00',
      SGST: '0.00',
      GSTCess: 0,
      netAmount: 0,
      editable: true,
      new: true,
    },
  ]);

  const [billingAddressDetails, setBillingAddressDetails] = useState({
    billingAddress: '',
    states: { label: '', value: '' },
    district: { label: '', value: '' },
       city: { label: '', value: '' },
    country: { label: '', value: '' },
    pincode: '',
    stateCD: '',
    countryCD: '',
    districtCD: '',
    gstin: '',
    customerName: '',

    errorStatus: {
      billingAddress: false,
      states: false,
      district: false,
      country: false,
      pincode: false,
      gstin: false,
      city:'',
      customerName: false,
    },
    errorFields: {
      billingAddress: '',
      states: '',
      district: '',
      country: '',
      pincode: '',
      gstin: '',
      city:'',
      customerName: '',
    },
  });
  const [deliveryAddressDetails, setDeliveryAddressDetails] = useState({
    deliveryAddress: '',
    states: { label: '', value: '' },
    district: { label: '', value: '' },
        city: { label: '', value: '' },
    country: { label: '', value: '' },
    pincode: '',
    stateCD: '',
    countryCD: '',
    districtCD: '',
    gstin: '',
    customerName: '',
    godown:'',

    errorStatus: {
      deliveryAddress: false,
      states: false,
      district: false,
      country: false,
      pincode: false,
      city:false,
      gstin: false,
      customerName: false,
      godown:false
    },
    errorFields: {
      deliveryAddress: '',
      states: '',
      district: '',
      country: '',
      pincode: '',
      gstin: '',
      city:'',
      customerName: '',
      godown:''
    },
  });
  const [initItemTableDta, setInitItemTableDta] = useState([]);
  const [initNonItemTableData, setInitNonItemTableData] = useState([]);
  const [invoiceMailModalOpen, setInvoiceMailModalOpen] = useState(false);
  const [aTags, setATags] = useState(document.getElementsByTagName('a').length);
  const [deletedNonItems, setDeletedNonItems] = useState([]);
  const [currentDouments, setCurrentDocuments] = useState([]);
  const [deletedItems, setDeletedItems] = useState([]);
  const [partyRowFrom, setPartyRowFrom] = useState(0);
  const [JETally,setJETally]=useState(0);

  let [modalOpen, setModalOpen] = useState(false);

  const [previewSalesTaxableModal, setPreviewSalesTaxableModal] = useState(false);

  return (
    <InvoiceStateListContext.Provider
      value={{
        resetData,
        resetItems,
        resetNonItems,
        initialState,
        setInitialState,
        data,
        setData,
        invID,
        setInvID,
        cancelModal,
        setCancelModal,
        state,
        setState,
        cancelModalStatus,
        setCancelModalStatus,
        itemData,
        setItemData,
        deleteModalStatus,
        setDeleteModalStatus,
        eImp,
        setEImp,
        eWayImp,
        setEwayImp,
        partyRowFrom,
        setPartyRowFrom,
        eObj,
        setEObj,
        accNames,
        setAccNames,
        viewMode,
        setViewMode,
        fromDayDate,
        setFromDayDate,
        endDayDate,
        setEndDayDate,
        paymentAccordion,
        setPaymentAccordion,
        deispatchAccordion,
        setDispatchAccordion,
        lastUsedCashAcc,
        lastUsedBankAcc,
        invoiceEntry,
        setInvoiceEntry,
        tcsOptionValue,
        setTcsoptionValue,
        tdsOptionValue,
        setTdsoptionValue,
        totTaxAmt,
        setTotTaxAmt,
        totDiscount,
        setTotDicount,
        totGSTCess,
        setTotGSTCess,
        totNetAmt,
        setTotNetAmt,
        totGST,
        setTotGST,
        totAmt,
        setTotAmt,
        companyState,
        setCompanyState,
        itemID,
        setItemID,
        itemType,
        setItemType,
        openAddItemModal,
        setOpenAddItemModal,
        netAmountToPay,
        setNetAmountToPay,
        amountAfterDiscount,
        setAmountAfterDiscount,
        amountAfterTCS,
        setAmountAfterTCS,
        amountAfterTDS,
        setAmountAfterTDS,
        companyData,
        setCompanyData,
        partyDeliveryAddressEntity,
        setPartyDeliveryAddressEntity,
        partyBillAddressEntity,
        setPartyBillAddressEntity,
        invTransArr,
        setInvTransArr,
        paymentTransArr,
        setPaymentTransArr,
        itemsRows,
        setItemsRows,
        initialAttachments,
        setInitialAttachments,
        tcsSections,
        setTcsSections,
        tdsSections,
        setTdsSections,
        transGeneralSettingsFlag,
        setTransGeneralSettingsFlag,
        partyNameOptions,
        setPartyNameOptions,
        partyAccountID,
        setPartyAccountID,
        linkedTransArr,
        setLinkedTransArr,
        voucherArr,
        setVoucherArr,
        transVoucherArr,
        setTransVoucherArr,
        paymentTransID,
        setPaymentTransID,
        displayAllAccounts,
        setDisplayAllAccounts,
        currentVoucherNo,
        setCurrentVoucherNo,
        backdropOpen,
        setBackdropOpen,
        units,
        setunits,
        unitsObj,
        setUnitsObj,
        lastInvoiceDate,
        setLastInvoiceDate,
        nextInvoiceDate,
        setNextInvoiceDate,
        firstInvoiceDate,
        setFirstInvoiceDate,
        position,
        setPosition,
        isDragging,
        setIsDragging,
        offset,
        setOffset,
        registrationType,
        setRegistrationType,
        tabvalue,
        setTabValue,
        itemValid,
        setItemValid,
        nonItemValid,
        setNonItemValid,
        isFocusItemRow,
        setIsFocusItemRow,
        isFocusNonItemRow,
        setIsNonItemFocusRow,
        partyType,
        setPartyType,
        tableErrArr,
        setTableErrArr,
        itemCodes,
        setItemCodes,
        itemNames,
        setItemNames,
        items,
        setItems,
        nonItems,
        setNonItems,
        billingAddressDetails,
        setBillingAddressDetails,
        deliveryAddressDetails,
        setDeliveryAddressDetails,
        initItemTableDta,
        setInitItemTableDta,
        initNonItemTableData,
        setInitNonItemTableData,
        invoiceMailModalOpen,
        setInvoiceMailModalOpen,
        modalOpen,
        setModalOpen,

        previewSalesTaxableModal,
        setPreviewSalesTaxableModal,

        selected,
        setSelected,
        aTags,
        setATags,
        listOfStates,
        setListOfStates,
        stateArr,
        setStateArr,
        countryArr,
        setCountryArr,
        districtArr,
        setDistrictArr,
        stateName,
        setStateName,
        districtName,
        setDistrictName,
        countryName,
        setCountryName,
        stateDelName,
        setStateDelName,
        districtDelName,
        setDistrictDelName,
        countryDelName,
        setCountryDelName,
        accountBalance,
        setAccountBalance,
        showTransactionModal,
        setShowTransactionModal,
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        partyAccName,
        setPartyAccName,
        itemListModalOpen,
        setItemListModalOpen,
        openPartyModal,
        setOpenPartyModal,
        partyCategery,
        setPartyCategery,
        newPartyID,
        setNewPartyID,
        partyParamsID,
        setPartyParamsID,
        partyID,
        setPartyID,
        purchaseArr,
        setPurchaseArr,
        companyGstType,
        setCompanyGstType,
        ledgerModal,
        setLedgerModal,
        companyPlaceofState,
        setCompanyPlaceOfState,
        openResetModal,
        setOpenResetModal,
        showAllCurrencies,
        setShowAllCurrencies,
        newChangeValue,
        setNewChangeValue,
        openAccountModal,
        setAddAccountModal,
        openBankAccountModal,
        setOpenBankAccountModal,
        cashAccount,
        setCashAccount,
        bankAccount,
        setBankAccount,
        openSettingsModal,
        setOpenSettingsModal,
        activeTransVouchers,
        setActiveTransVouchers,
        transSerielNos,
        setTransSerielNo,
        newTransVouch,
        setNewTransVouch,
        focus,
        setFocus,
        newSerilNo,
        setNewSerialNo,
        LastBankAccount,
        setLastBankAccount,
        openPaymentWarningModal,
        setOpenPaymentWarningModal,
        currentPaymentAccObj,
        setCurrentPaymentAccObj,
        cashPaymentObj,
        setCashPaymentObj,
        bankPaymentObj,
        setBankPaymentObj,
        generalSettingsFlag,
        setGeneralSettingsFlag,
        activeVouchers,
        setActiveVouchers,
        serialNos,
        setSerialNos,
        deletedItems,
        setDeletedItems,
        deletedNonItems,
        setDeletedNonItems,
        currentDouments,
        setCurrentDocuments,
        originalInvoiceNos,
        setOriginalInvoiceNos,
        JETally,setJETally
      }}
    >
      {children}
    </InvoiceStateListContext.Provider>
  );
};

export const useStateList = () => useContext(InvoiceStateListContext);
